exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".badge__28Cv6{width:.75em;height:.75em;display:block;border-radius:1em;background:red;position:absolute;top:1em;right:1em;border:.125em solid #fff}", "", {"version":3,"sources":["C:/dev/globalTopBar/src/components/sections/personal-area/sections/notification/notifications-button/C:/dev/globalTopBar/src/components/sections/personal-area/sections/notification/notifications-button/C:/dev/globalTopBar/src/components/sections/personal-area/sections/notification/notifications-button/styles.scss"],"names":[],"mappings":"AAAA,cACE,YACA,aACA,cACA,kBACA,eACA,kBACA,QACA,UACA,wBAA0B,CAC3B","file":"styles.scss","sourcesContent":[".badge {\n  width: .75em;\n  height: .75em;\n  display: block;\n  border-radius: 1em;\n  background: red;\n  position: absolute;\n  top: 1em;\n  right: 1em;\n  border: .125em solid white;\n}\n"],"sourceRoot":""}]);

// exports
exports.locals = {
	"badge": "badge__28Cv6"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader??ref--4-2!../node_modules/postcss-loader/lib??postcss!../node_modules/preact-cli/lib/lib/webpack/proxy-loader.js??ref--2-0!./components/sections/personal-area/sections/notification/notifications-button/styles.scss
// module id = oJgK
// module chunks = 0